import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { defaultConfig, defaultTheme } from './constants';
import { AuthProvider, ConfigProvider, ThemeProvider, ToastProvider } from './hoc';
import './index.css';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(ThemeProvider, { theme: defaultTheme, children: _jsx(ConfigProvider, { config: defaultConfig, children: _jsx(ToastProvider, { children: _jsx(AuthProvider, { children: _jsx(App, {}) }) }) }) }) }));
